(function() { module.exports = window["Bernie_l10nBundle_en_SG"]; }());